<div class="loader-wrapper">
  <img src="/assets/images/Atlas-Logo-V3-Loading-Animation-Loop.gif" alt="Loading spinner" />
  <!--<p class="tip-text"> {{currentTip}} </p>-->
</div>
